import * as types from './actionTypes';

const initialState = null;

export default function reducerFilterFields(state = initialState, action) {
  switch (action.type) {
    case types.SET:
      return action.payLoad;

    case types.CLEAR:
      return null;

    default:
      return state;
  }
}
